import React, { useMemo } from 'react'
import MemoLibraryBooks from '../Icons/LibraryBooks'
import { styled } from 'goober'
import { useTheme } from '../../../hooks/useTheme'

// Create styled component outside of the component to prevent re-creation
const createDocsComponentContainer = (theme, isDarkMode) => {
  const documentTypeColorCoding = {
    pdf: {
      iconColor: isDarkMode ? 'rgba(172, 82, 82, 1)' : 'rgba(212, 121, 121, 1)',
      background: isDarkMode
        ? 'rgba(172, 82, 82, 0.2)'
        : 'rgba(218, 118, 118, 0.15)',
      title: 'PDF'
    },
    xlsx: {
      iconColor: isDarkMode ? 'rgba(51, 143, 104, 1)' : 'rgba(85 ,149 ,121,1)',
      background: isDarkMode
        ? 'rgba(51, 143, 104, 0.2)'
        : 'rgba(69, 125, 101, 0.15)',
      title: 'XLSX'
    },
    xls: {
      iconColor: isDarkMode ? 'rgba(51, 143, 104, 1)' : 'rgba(85, 149, 121, 1)',
      background: isDarkMode
        ? 'rgba(51, 143, 104, 0.2)'
        : 'rgba(69, 125, 101, 0.15)',
      title: 'XLS'
    },
    docx: {
      iconColor: isDarkMode
        ? 'rgba(106, 159, 205, 1)'
        : 'rgba(101, 162, 219, 1)',
      background: isDarkMode
        ? 'rgba(106, 159, 205, 0.2)'
        : 'rgba(123, 175, 225, 0.15)',
      title: 'DOCX'
    },
    doc: {
      iconColor: isDarkMode
        ? 'rgba(106, 159, 205, 1)'
        : 'rgba(101, 162, 219, 1)',
      background: isDarkMode
        ? 'rgba(106, 159, 205, 0.2)'
        : 'rgba(123, 175, 225, 0.15)',
      title: 'DOC'
    },
    txt: {
      iconColor: isDarkMode ? 'rgba(185, 168, 75, 1)' : 'rgba(201, 184, 91, 1)',
      background: isDarkMode
        ? 'rgba(185, 168, 75, 0.2)'
        : 'rgba(206, 192, 116, 0.15)',
      title: 'TXT'
    }
  }

  return styled('div')(({ docType = 'txt' }) => {
    const docConfig =
      documentTypeColorCoding[docType.toLowerCase()] ||
      documentTypeColorCoding.txt
    return {
      width: '50px',
      height: '50px',
      borderRadius: '5px',
      background: docConfig.background,
      color: docConfig.iconColor,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }
  })
}

export const DocumentComponent = ({ docType = 'txt' }) => {
  const theme = useTheme()
  const isDarkMode = theme.palette.mode === 'dark'

  // Memoize the styled component creation to prevent recreation on every render
  const DocsComponentContainer = useMemo(
    () => createDocsComponentContainer(theme, isDarkMode),
    [theme, isDarkMode]
  )

  const modifiedDocType = typeof docType === 'string' ? docType : 'txt'

  return (
    <DocsComponentContainer docType={modifiedDocType}>
      <MemoLibraryBooks fontSize='small' />
      <p style={{ fontSize: '0.6rem', margin: '5px 0 0 0' }}>
        {modifiedDocType.toUpperCase()}
      </p>
    </DocsComponentContainer>
  )
}

export const NotificationMedia = ({ type, attachmentsObject, showBlur }) => {
  const attachment = attachmentsObject?.attachment || ''
  const isDocument = attachmentsObject?.type === 'Document' || false
  const docType = isDocument
    ? attachment?.substring(attachment.lastIndexOf('.') + 1)
    : null

  switch (type) {
    case 'Image':
      return (
        <img
          alt='user-image'
          src={attachment}
          width='50rem'
          height='50rem'
          style={{ borderRadius: 5 }}
        />
      )
    case 'Video':
      return (
        <video
          src={attachment}
          width='50rem'
          height='50rem'
          style={{ borderRadius: 5 }}
        />
      )
    case 'Document':
      return <DocumentComponent docType={docType} showBlur={showBlur} />
    default:
      return null
  }
}
